import * as React from "react";
import * as _ from "underscore";

import { CQMCheck } from "@eave/shared/types/api";
import CQMCheckSection from "./CQMCheckSection";

const classnames = require("classnames");

interface CQMCheckSectionsProps {
  checks: {
    length: number;
    map: Function;
    [index: number]: CQMCheck;
  };
  onToggle: Function;
}

class CQMCheckSections extends React.Component<CQMCheckSectionsProps, any> {
  render() {
    const { checks, onToggle } = this.props;

    return (
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th className="col-sm-1 text-center">OK</th>
            <th>Check details</th>
          </tr>
        </thead>
        <tbody>
          {checks.map(chk => {
            const okClasses = classnames({
              fa: true,
              "fa-square-o": !chk.ok,
              "fa-check-square-o": chk.ok,
            });

            return (
              <tr key={chk.name} className="cqm-info-review__row">
                <td
                  className="cqm-info-review__clickable text-center"
                  onClick={onToggle.bind(this, chk.name)}
                >
                  <i className={okClasses} />
                </td>
                <td>
                  <div className="cqm-info-review__desc">{chk.description}</div>
                  <CQMCheckSection {...chk} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default CQMCheckSections;
